import { render, staticRenderFns } from "./DeleteProveedorModal.vue?vue&type=template&id=05b74e23&"
import script from "./DeleteProveedorModal.vue?vue&type=script&lang=js&"
export * from "./DeleteProveedorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports